import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';
import { NewsCard } from '../components/NewsCard';
import { Seo } from '../components/Seo';
import { articles } from '../data/articles';
export function NewsPage() {
  const [featuredArticle, ...remainingArticles] = articles;
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-303" data-mp="20k2qmuuhb8ab">
      <Seo title="News & Updates for Arizona Cities and Towns" description="Read AZ City PAC updates on Arizona local voices, local decision-making, responsible growth, land use, infrastructure, and stronger communities." path="/news" schema={{
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'AZ City PAC News & Updates',
      description: 'Updates and perspectives on local voices, local decision-making, infrastructure, and Arizona communities.',
      url: 'https://azcitypac.com/news',
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: articles.map((article, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          url: `https://azcitypac.com/news/${article.slug}`,
          name: article.title
        }))
      }
    }} data-id="element-304" data-mp="20ijftjrldpfx" />
      <Navbar data-id="element-305" data-mp="1f4g300q9tk3r" />
      <main className="flex-grow pt-24" data-id="element-306" data-mp="1f4zk5f83k4gq">
        <section className="bg-pac-navy py-16 md:py-24 text-white" data-id="element-307" data-mp="1f60xxrghz525">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-308" data-mp="1j5rt07d247ch">
            <p className="text-pac-gold font-bold uppercase tracking-[0.2em] text-sm mb-4" data-id="element-309" data-mp="1o4338j79kjv8">
              AZ City PAC
            </p>
            <h1 className="font-serif text-5xl md:text-6xl font-bold mb-5" data-id="element-310" data-mp="1t50hwlt2evrz">News & Updates</h1>
            <p className="text-xl text-slate-300 max-w-2xl leading-relaxed" data-id="element-311" data-mp="2zizulzqx7l5r">
              Perspectives and updates from Arizona&apos;s statewide coalition for stronger local leadership.
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24" data-id="element-312" data-mp="29vdykne2z184">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-313" data-mp="29ucczozfuwc5">
            <p className="text-pac-red font-bold uppercase tracking-[0.18em] text-sm mb-5" data-id="element-314" data-mp="2osd13wu2s3vq">Featured update</p>
            <NewsCard article={featuredArticle} featured data-id="element-315" data-mp="2jt0ixpe5fkzh" />

            <div className="flex items-end justify-between gap-6 mt-20 mb-8 border-b border-slate-200 pb-6" data-id="element-316" data-mp="2jrh29xokz7x6">
              <div data-id="element-317" data-mp="1w1mqzkjwtrf1">
                <h2 className="font-serif text-4xl font-bold text-pac-navy" data-id="element-318" data-mp="1r5ee6dt6qab1">From the coalition</h2>
                <p className="text-slate-600 mt-2" data-id="element-319" data-mp="25uaiq0w1956w">The latest work and conversations shaping Arizona communities.</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-320" data-mp="211r6p8czui47">
              {remainingArticles.map(article => <NewsCard key={article.slug} article={article} data-id="element-321" data-mp="18eeiktr6q28s" />)}
            </div>

            <div className="mt-16" data-id="element-322" data-mp="3k1qevznlg6cu">
              <Link to="/" className="inline-flex items-center gap-2 text-pac-blue font-bold hover:text-pac-navy transition-colors focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 rounded" data-id="element-323" data-mp="3k1gqggi76799">
                <ArrowLeft className="h-4 w-4" data-id="element-324" data-mp="3f2n8aaryts2r" />
                Return to AZ City PAC
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-325" data-mp="6nddzoubhr5j" />
    </div>;
}